import classnames from 'classnames';
import { PropsWithChildren, ReactNode, useCallback } from 'react';

import { Theme } from '../../types/theme.type';
import { RolePermission } from '../../types/operator.type';
import { useSettingsStore } from '../../store/settings-store';

type Props = PropsWithChildren & {
    theme: Theme;
    permissions?: RolePermission[];
    requiredPermission?: string;
};

const View = ({ theme, permissions, requiredPermission, children }: Props) => {
    const { menuCollapsed } = useSettingsStore();

    const renderByPermissions: () => ReactNode = useCallback(() => {
        if (!requiredPermission) return children;
        const permission = permissions?.find(
            (per) => per.name === requiredPermission
        );
        if (!permission) return <NoPermissions />;

        return children;
    }, [children, permissions, requiredPermission]);

    return (
        <main
            className={classnames(['view', theme.current === 'dark' && 'dark'])}
            style={{ marginLeft: menuCollapsed ? 60 : 200 }}
        >
            {renderByPermissions()}
        </main>
    );
};

const NoPermissions = () => (
    <div
        style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <span style={{ fontSize: 18 }}>
            No tienes permisos para acceder a esta vista
        </span>
    </div>
);

export default View;
